import styled from 'styled-components';

export const StyledCustomButton = styled.button`
	display: inline-block;
	background-color: #ff5975;
	color: white;
	font-size: 18px;
	font-weight: 600;
	width: 100%;
	text-align: center;
	text-decoration: none;
	padding: 12px 12px;
	border: none;
	border-radius: 5px;
	box-sizing: border-box;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
`;
